/* eslint-disable react/no-multi-comp,react/jsx-props-no-spreading */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@rebass/grid';
import { Formik, Field, Form } from 'formik';

import { Text1, Button, Text4 } from 'app/shared/ui';
import {
  MobileSuccessModal,
  successTranslationsShape,
} from 'app/marketplace/SlideInBanners/shared/Components/MobileSuccessModal/MobileSuccessModal';
import { MessageText } from 'app/marketplace/contentful/spaces/heycar/components/MessageText/MessageText';
import { ConnectedModal } from 'app/shared/modules/overlay/defaultOverlays/modal/Modal';
import { handleEmailValidation } from 'app/marketplace/accounts/helpers/handleValidators';
import { color } from 'app/shared/styles_js/variables';

import { InputBoxFieldSt, OverlayTitleSt } from './MobileForm.css';

export const MobileForm = ({
  source,
  onFormSubmit,
  finishSubmit,
  openOverlay,
  closeOverlay,
  tracking,
  formTranslations,
  successTranslations,
}) => {
  const [serverError, setServerError] = useState(null);
  const handleSubmit = async ({ email }, { setSubmitting }) => {
    tracking.init();
    try {
      await onFormSubmit({ email, source });
      finishSubmit();
      setSubmitting(false);
      tracking.success();
      setServerError(false);
      openOverlay(MobileSuccessModal, {
        props: {
          closeOverlay,
          successTranslations,
        },
      });
    } catch (error) {
      setServerError(true);
      tracking.failure();
      setSubmitting(false);
    }
  };

  return (
    <ConnectedModal
      ariaLabel="crm subscription modal"
      title={<OverlayTitleSt>{formTranslations.title}</OverlayTitleSt>}
    >
      <Formik onSubmit={handleSubmit} initialValues={{ email: '' }}>
        {({ errors: clientErrors, isValid, isSubmitting }) => {
          const showEmailError = clientErrors.email || serverError;
          return (
            <Form>
              <Text1 mb={16} mt={0}>
                {formTranslations.formText}
              </Text1>
              <Box>
                <Field
                  component={InputBoxFieldSt}
                  name="email"
                  type="email"
                  required
                  validate={handleEmailValidation}
                  label="E-Mail"
                  compact
                  autoFocus
                />
                <MessageText>
                  {showEmailError &&
                    (clientErrors.email || formTranslations.userEmailError)}
                </MessageText>
              </Box>
              <Button
                width={1}
                isLoading={isSubmitting}
                disabled={!isValid}
                type="submit"
              >
                {formTranslations.formButton}
              </Button>
            </Form>
          );
        }}
      </Formik>
      <Text4
        as="p"
        color={color.grayDarker}
        mt={19}
        fontSize="8px"
        textAlign="center"
      >
        {formTranslations.disclaimer}
      </Text4>
    </ConnectedModal>
  );
};

export const formTranslations = PropTypes.shape({
  title: PropTypes.object,
  formText: PropTypes.object,
  userEmailError: PropTypes.object,
  formButton: PropTypes.object,
  disclaimer: PropTypes.object,
});

MobileForm.propTypes = {
  source: PropTypes.string.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  finishSubmit: PropTypes.func.isRequired,
  tracking: PropTypes.object.isRequired,
  openOverlay: PropTypes.func.isRequired,
  closeOverlay: PropTypes.func.isRequired,
  formTranslations: formTranslations.isRequired,
  successTranslations: successTranslationsShape.isRequired,
};
